<template>
  <div>
    <modal
      :show.sync="addEmbed"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      footerClasses=""
      size="lg"
      bodyClasses=""
      @close="closeModal"
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Add Embedded
      </h6>
      <div>
        <base-input
          v-model="name"
          placeholder="Enter name"
          class="cust-mb0"
          :rules="{ required: true }"
          name="name"
        ></base-input>
        <base-input
          v-model="url"
          placeholder="Enter URL"
          class="cust-mb0"
          :rules="{ required: true }"
          name="embedded"
        ></base-input>

        <!-- <b-button type="primary"
          >Create Chapter</b-button -->
      </div>
      <template slot="footer">
        <base-button type="primary" @click.once="handleAdd()"
          >ADD EMBEDDED</base-button
        >
        <base-button type="secondary" class="ml-auto" @click="closeModal"
          >CLOSE</base-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      url: "",
    };
  },
  props: {
    addEmbed: Boolean,
    chapter: Object,
  },

  methods: {
    closeModal() {
      this.name = "";
      this.url = "";
      this.$emit("close-addEmbed");
    },

    async handleAdd() {
      let loader = this.$loading();
      try {
        const data = await this.$store.dispatch("eLearning/addEmbedded", {
          url: this.url,
          name: this.name,
          chapter: this.chapter._id,
        });
        if (data.code == 200) {
          loader.close();
          await this.$store.dispatch("eLearning/getChapterByCourseId", {
            id: this.chapter.course[0],
          });
          this.$swal.fire({
            title: "Added",

            text: "Added Successfully!",

            icon: "success",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
          this.closeModal();
        }
      } catch (err) {
        loader.close();
      }
    },
  },
};
</script>
